(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/bankid/other-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/bankid/other-device.js');

'use strict';

const _svs$accountservices$ = svs.accountservices.authenticate.definitions,
  AuthenticateEvents = _svs$accountservices$.Events,
  LoginTypes = _svs$accountservices$.LoginTypes,
  BankidStatus = _svs$accountservices$.BankidStatus;
svs.player_login.views.bankid.OtherDevice = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.bankid_other_device(data);
  },
  templateContext() {
    return {
      viewData: {
        useSsn: this.model.get('loginMethod') === LoginTypes.DESKTOP_BANKID_MOBILE_SSN && !svs.core.detect.feature('ft-delete-bankid-ssn')
      }
    };
  },
  regions: {
    deviceInput: '.js-device-input-region'
  },
  ui: {
    qrContainer: '.js-qr-container',
    ssnTabButton: '.js-ssn-tab-button',
    qrTabButton: '.js-qr-tab-button',
    ssnTab: '.js-ssn-tab',
    qrTab: '.js-qr-tab',
    qrHelp: '.js-qr-help',
    retryButton: '.js-retry',
    qrSpinner: '.js-qr-spinner',
    prolongBtn: '.js-prolong-btn',
    qrCountdown: '.js-qr-countdown',
    qrCountdownAria: '.js-qr-countdown-aria',
    prolongQr: '.js-prolong-qr'
  },
  events: {
    'click @ui.qrHelp': 'onQrHelpClick',
    'click @ui.ssnTabButton': 'onSsnTabButtonClick',
    'click @ui.qrTabButton': 'onQrTabButtonClick',
    'click @ui.retryButton': 'onRetryClick',
    'click @ui.prolongBtn': 'onProlongClick'
  },
  behaviors: [svs.player_login.behaviors.Login, svs.player_login.behaviors.Navigation, svs.player_login.behaviors.About, svs.player_login.behaviors.InputSsn],
  initialize() {
    this.qrIsActive = true;
    this.gotError = false;
    this.navigateToPoll = false;
    this.authenticateEvents = {
      [AuthenticateEvents.READY_TO_POLL]: this.onReadyToPoll,
      [AuthenticateEvents.NOT_STARTED]: this.startBankID,
      [AuthenticateEvents.RETRY]: this.generateQR,
      [AuthenticateEvents.QR_UPDATE]: this.generateQR,
      [AuthenticateEvents.RETRIES_FINISHED]: this.onRetriesFinished,
      [AuthenticateEvents.TIMEOUT_TYPE_UPDATED]: this.onTimeoutType,
      [AuthenticateEvents.ONE_RETRY_LEFT]: this.onOneRetryLeft
    };
    svs.accountservices.authenticate.login.on(this.authenticateEvents, this);
  },
  onOneRetryLeft() {
    this.getUI('qrCountdown').text('30');
    this.getUI('prolongQr').removeClass('hide');
    this.getUI('qrCountdownAria').text('30').parent().attr('role', 'alert');
    let countdown = 29;
    let countdownAria = 30;
    const ariaInterval = 10;
    this.interval = setInterval(() => {
      if (countdown >= 0) {
        this.getUI('qrCountdown').text(countdown--);
      } else {
        clearInterval(this.interval);
      }
    }, 1000);
    this.intervalAria = setInterval(() => {
      if (countdown > 0) {
        countdownAria = countdownAria - ariaInterval;
        this.getUI('qrCountdownAria').text(countdownAria);
      } else {
        clearInterval(this.intervalAria);
      }
    }, 1000 * ariaInterval);
  },
  onTimeoutType(_ref) {
    let pollStatus = _ref.pollStatus;
    if (this.qrIsActive && pollStatus === BankidStatus.DELIVERED_TO_MOBILE) {
      this.getUI('qrContainer').empty().html(svs.player_login.templates.qr_spinner());
      this.bindUIElements();
      this.loader = new svs.components.Loader(this.getUI('qrSpinner'));
      this.loader.show(300, 'inverted');
    }
  },
  startBankID() {
    if (!this.gotError && this.qrIsActive) {
      this.loader = new svs.components.Loader(this.getUI('qrSpinner'));
      this.loader.show(300, 'inverted');
      svs.accountservices.authenticate.login.start({
        qr: true,
        codeChallenge: this.model.get('codeChallenge'),
        codeChallengeMethod: this.model.get('codeChallengeMethod'),
        isCustomerRegistration: this.model.get('isCustomerRegistration'),
        isPoker: this.model.get('isPoker')
      });
    }
  },
  onProlongClick() {
    this.onRetryClick();
  },
  onRetryClick() {
    this.getUI('qrContainer').empty().html(svs.player_login.templates.qr_spinner());
    this.getUI('prolongQr').addClass('hide');
    this.bindUIElements();
    this.loader = new svs.components.Loader(this.getUI('qrSpinner'));
    this.loader.show(300, 'inverted');
    svs.accountservices.authenticate.login.start({
      qr: true,
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onRetriesFinished() {
    this.getUI('qrContainer').empty().html('<p aria-live="polite" role="alert" class="padding-top-4">Inloggningen tog för lång tid.</p>');
  },
  onError() {
    if (this.qrIsActive) {
      this.getUI('prolongQr').addClass('hide');
      this.gotError = true;
      this.getUI('qrContainer').empty().html(svs.player_login.templates.get_new_qr());
    }
  },
  onReadyToPoll(data) {
    this.model.set('loginToken', data.loginToken);
    if (data.ssn) {
      this.navigateToPoll = true;
      svs.player_login.router.navigate("bankid/poll?".concat(this.model.toQueryString()), true);
    } else {
      this.generateQR(data.qrData);
      if (this.qrIsActive) {
        svs.accountservices.authenticate.login.poll();
      }
    }
  },
  generateQR(qrData) {
    this.getUI('qrContainer').empty().qrcode({
      size: 120,
      color: '#3a3',
      text: qrData
    });
  },
  onAttach() {
    if (this.model.get('loginMethod') === LoginTypes.DESKTOP_BANKID_MOBILE_SSN && !svs.core.detect.feature('ft-delete-bankid-ssn')) {
      this.qrIsActive = false;
    } else {
      this.qrIsActive = true;
      this.loader = new svs.components.Loader(this.getUI('qrSpinner'));
      this.loader.show(300, 'inverted');
      svs.accountservices.authenticate.login.start({
        qr: true,
        codeChallenge: this.model.get('codeChallenge'),
        codeChallengeMethod: this.model.get('codeChallengeMethod'),
        isCustomerRegistration: this.model.get('isCustomerRegistration'),
        isPoker: this.model.get('isPoker')
      });
    }
  },
  onSsnTabButtonClick() {
    if (svs.core.detect.feature('ft-delete-bankid-ssn')) {
      return false;
    }
    if (this.qrIsActive) {
      this.ui.qrTabButton.removeClass('btn-inverted').addClass('btn-transparent-default');
      this.ui.ssnTabButton.removeClass('btn-transparent-default').addClass('btn-inverted');
      this.ui.qrTab.removeClass('active');
      this.ui.ssnTab.addClass('active');
      this.qrIsActive = false;
      svs.accountservices.authenticate.login.pause();
    }
  },
  onBeforeError() {
    if (this.loader) {
      this.loader.hide();
    }
  },
  onQrTabButtonClick() {
    if (!this.qrIsActive) {
      this.ui.ssnTabButton.removeClass('btn-inverted').addClass('btn-transparent-default');
      this.ui.qrTabButton.removeClass('btn-transparent-default').addClass('btn-inverted');
      this.ui.ssnTab.removeClass('active');
      this.ui.qrTab.addClass('active');
      this.qrIsActive = true;
      svs.accountservices.authenticate.login.resume();
    }
  },
  onQrHelpClick() {
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
      title: ' ',
      icon: 'help-2',
      actions: [{
        title: 'Stäng'
      }],
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.LEFT,
        text: "<div tabindex=\"0\">1. \xD6ppna din BankID-app i din mobila enhet.<br>\n                   2. V\xE4lj QR-kod/QR-Code.<br>\n                   3. L\xE4s av QR-koden med din mobila enhet.<br>\n                   4. Identifiera dig med kod eller fingeravtryck i BankID-appen.</div>"
      }]
    }));
  },
  onSsnSubmit() {
    svs.accountservices.authenticate.login.start({
      ssn: this.model.get('ssn'),
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onDestroy() {
    clearInterval(this.intervalAria);
    clearInterval(this.interval);
    svs.accountservices.authenticate.login.off(this.authenticateEvents);
    if (!this.navigateToPoll) {
      svs.accountservices.authenticate.login.cancel();
    }
  }
});

 })(window);